import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const marginFixStyle = css`
  margin-left: ${theme.spacing(1)};
`;

export const optionalTextStyle = css`
  font-size: ${theme.font.size.large};
  font-weight: ${theme.font.weight.regular};
  margin-left: ${theme.spacing(0.5)};
  @media screen and (max-width: ${breakpoints.small.max}px) {
    font-size: ${theme.font.size.medium};
  }
`;

export const textStyle = css`
  @media screen and (max-width: ${breakpoints.small.min}px) {
    font-size: ${theme.font.size.h3};
  }
`;
